<template>
  <div class="task" v-if="task">
    <div class="row">
      <div class="col-6">
        <div class="">
          <h3>任务文件
            <button class='btn btn-primary' @click='exportOrderSpreadsheet()'>导出</button>
            <button class="btn btn-primary" @click="resetTask()">撤销任务</button>
            <button class="btn btn-primary" @click="redoTask()">再次执行</button>
            <button class="btn btn-primary" @click="redownloadMissingFiles()">下载缺失文件</button>
          </h3>

          <form class='form-inline' enctype='multipart/form-data' id='export-spreadsheet-form' method='post' action='/api/orders/spreadsheet'>       
            <input type='hidden' name='name' value='export-order-spreadsheet'>
            <input type='hidden' name='order_nos' value=''>
            <input type='hidden' name='filename' :value="task.name + '.xlsx'">
          </form>

          <div v-if="files">
            <table class="table table-sm">
              <thead>
                <tr>
                  <th></th>
                  <th>订单号</th>
                  <th>公司</th>
                  <th>个数</th>
                  <th>打印的文件</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for='(file, index) in files'>
                  <td>{{index + 1}}</td>
                  <td :data-order-no="file.order.order_no" class="order_no">
                    <a :href="'/orders/' + file.order.order_no">{{ file.order.order_no }}</a><br/>
                    {{ file.order.company_order_no }}

                  </td>
                  <td>{{ getCompanyDisplay(file.order.company_code) }}</td>
                  <td>{{ file.count }}</td>
                  <td><a :href="'/media/' + file.filepath">{{ file.filepath.split('/').pop() }}</a></td>
                </tr>
              </tbody>
            </table>
          </div>

          <div v-if="orders">
            <table class="table table-hover">
              <thead>
                <th></th>
                <th>公司</th>
                <th>内部订单号</th>  
                <th>外部订单号</th>  
              </thead>
              <tbody>
                <tr v-for="(order, index) in orders">
                  <td>{{index + 1}}</td>
                  <td>{{getCompanyDisplay(order.company_code)}}</td>
                  <td :data-order-no="order.order_no" class="order_no"><a :href="'/orders/' + order.order_no">{{order.order_no}}</a></td>
                  <td>{{order.company_order_no}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="col-6">
        <div>
          <h3>
              任务
              <span><button class="btn btn-primary" @click="renameTask">修改任务名</button></span>
          </h3>
          <table class='table'>
            <thead>
              <th>ID</th>
              <th>任务名</th>
              <th>任务类型</th>
              <th>创建时间</th>
              <th>产品类型</th>
              <th>订单</th>
              <th>页数</th>
              <th>状态</th>
            </thead>
            <tbody>
              <tr v-if='task'>
                <td><a :href="'/tasks/' + task.id">{{task.id}}</a></td>
                <td>{{task.name}}</td>
                <td>{{getTaskTypeDisplay(task.task_type)}}</td>
                <td>
                  <local-time :time="task.created_at"></local-time>
                </td>
                <td>{{task.arg1}}</td>
                <td>{{task.data.order_nos ? task.data.order_nos.length:task.arg2}}个</td>
                <td>{{task.data.page_count || '未知'}}</td>
                <td>{{getTaskStatusDisplay(task.status)}}</td>
                <td></td>
              </tr>
            </tbody>  
          </table>
        </div>

        <div v-if="task.data.pdf_path">
          <h3>合成文件</h3>
          <table class="table">
            <tbody>
              <tr v-for="file in task.data.pdf_path">
                <td><a target="_blank" :href="generateMedia2Path(file, task.data.printer_folder)">{{generateMedia2Path(file, task.data.printer_folder)}}</a></td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="operation-history mt-5 " v-if="logs.length">
          <h3>操作历史</h3>
          <table class="table table-sm">
            <thead>
              <tr>
                <th>时间</th>
                <th>用户</th>
                <th>内容</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="log in logs">
                <td><local-time :time="log.created_at"></local-time></td>
                <td>{{log.commander || ''}}</td>
                <td>{{log.message}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InputMixin from '@/mixins/input'
import OrderMixin from '@/mixins/order'
import TaskMixin from '@/mixins/task'
import LocalTime from '@/components/_small/LocalTime'
import {showFailedAlert} from '@/utils/alert'

function exportOrderSpreadsheet () {
  var orderNos = []
  document.querySelectorAll('.order_no').forEach(function (element) {
    orderNos.push(element.getAttribute('data-order-no'))
  })

  var form = document.getElementById('export-spreadsheet-form')
  form.querySelector('input[name="order_nos"]').setAttribute('value', orderNos.join(','))
  form.submit()
}

function resetTask () {
  let result = confirm('确定撤销任务？')
  if (!result) {
    return
  }

  var taskId = this.task.id
  this.$http.post('/api/tasks/' + taskId + '/reset')
}

function redoTask () {
  let result = confirm('确定再次执行？')
  if (!result) {
    return
  }

  var taskId = this.task.id
  this.$http.post('/api/tasks/' + taskId + '/redo')
}

function redownloadMissingFiles () {
  var taskId = this.task.id
  this.$http.post('/api/tasks/' + taskId + '/redownload')
}

function renameTask () {
  const name = prompt('请输入任务名').trim()
  if (!name) {
    showFailedAlert('任务名为空')
    return
  } else if (name.length > 20) {
    showFailedAlert('任务名最长20个字')
    return
  }

  this.$http.put(
    `/api/tasks/${this.task.id}`,
    {
      'name': name
    }
  ).then(this.loadData)
}

function loadData () {
  this.$http.get('/api/tasks/' + this.$route.params.task_id).then(response => {
    this.task = response.data.data
    this.files = this.task.files
    this.orders = this.task.orders
  })
  .catch(function (error) {
    console.log(error)
  })

  // make request for loggers
  this.$http.get('/api/tasks/' + this.$route.params.task_id + '/logs').then(response => {
    this.logs = response.data.data
  })
  .catch(function (error) {
    console.log(error)
  })
}

function generateMedia2Path (file, printerFolder) {
  // 如果没有printerFolder, 截取`打印任务`后面的内容
  let key = printerFolder
  if (!printerFolder) {
    key = "/打印任务"
  }
  let result = file.split(key, 2)
  let path = result[result.length - 1]

  if (!path.startsWith('/')) {
    path = '/' + path
  }
  return '/media2' + path
}

export default {
  name: 'task',
  mixins: [InputMixin, OrderMixin, TaskMixin],
  data () {
    return {
      'task': null,
      'files': [],
      'logs': []
    }
  },
  components: {
    LocalTime
  },
  created () {
    // Make a request for a user with a given ID
    this.loadData()
  },
  methods: {
    exportOrderSpreadsheet,
    resetTask,
    redoTask,
    redownloadMissingFiles,
    renameTask,
    loadData,
    generateMedia2Path
  }
}
</script>


<style lang='scss' scoped>
</style>